import React from 'react';
import { TotalEntries } from '../../components';
import { useQueryParams } from '../../queryParams/useQueryParams';
import { FieldPath, FieldValues, useWatch } from 'react-hook-form';
import { FormContentSegmentOption } from './FormSegments';

export interface FormSegmentTotalEntriesProps<Segment extends string> {
  segments: FormContentSegmentOption<Segment>[];
}

export const FormSegmentTotalEntries = <Segment extends string = string>(
  props: FormSegmentTotalEntriesProps<Segment>
) => {
  const { segments } = props;
  const [queryParams] = useQueryParams();
  const currentSegment = queryParams.segment || segments[0].value;
  const segment = segments.find((item) => item.value === currentSegment);
  return segment?.formFieldName ? (
    <FormSegmentTotalEntriesInner
      name={
        Array.isArray(segment.formFieldName)
          ? segment.formFieldName
          : [segment.formFieldName]
      }
    />
  ) : (
    <TotalEntries count={segment?.count} />
  );
};

export interface FormSegmentTotalEntriesInnerProps<
  FormData extends FieldValues,
  Name extends FieldPath<FormData>
> {
  name: Name[];
}

export const FormSegmentTotalEntriesInner = <
  FormData extends FieldValues,
  Name extends FieldPath<FormData>
>(
  props: FormSegmentTotalEntriesInnerProps<FormData, Name>
) => {
  const { name } = props;
  const formFields = useWatch({ name });

  return (
    <TotalEntries
      count={formFields?.find((formField) => formField?.length)?.length}
    />
  );
};
